import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, Layers, Brain, TrendingUp } from 'lucide-react';
const benefits = [{
  icon: Clock,
  title: 'En 30 Minutos',
  desc: 'Producí creativos estratégicos en minutos, no horas. Sin curva de aprendizaje.'
}, {
  icon: Layers,
  title: 'Multiformato',
  desc: 'Carruseles, VSLs, Reels, Newsletters — todo desde un solo sistema.'
}, {
  icon: Brain,
  title: 'Sistema Estratégico',
  desc: 'Generá el ángulo correcto sin adivinar: dolor, deseo, FOMO o identidad.'
}, {
  icon: TrendingUp,
  title: 'Mejora CTR',
  desc: 'Mejorá tus métricas con ángulos psicológicos probados en campañas reales.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-black py-16 px-4" data-id="element-30">
      <div className="max-w-7xl mx-auto" data-id="element-31">
        <div className="text-center mb-10" data-id="element-32">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-33">
            Qué Vas a Lograr con{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-34">
              PromptAdsPro
            </span>
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-35">
          {benefits.map((benefit, idx) => <motion.div key={idx} variants={cardVariants} className="group relative bg-premium-mid/60 border border-matrix-green/20 rounded-2xl p-6 md:p-8 hover:border-matrix-green/50 transition-all duration-300 hover:shadow-[0_0_25px_rgba(0,255,65,0.15)]" data-id="element-36">
              <div className="absolute inset-0 bg-gradient-to-br from-matrix-green/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl pointer-events-none" data-id="element-37" />

              <div className="relative z-10" data-id="element-38">
                <div className="w-14 h-14 rounded-xl bg-matrix-green/15 border border-matrix-green/30 flex items-center justify-center mb-5 group-hover:shadow-[0_0_20px_rgba(0,255,65,0.3)] transition-shadow duration-300" data-id="element-39">
                  <benefit.icon className="w-7 h-7 text-matrix-green" data-id="element-40" />
                </div>

                <h3 className="font-heading font-bold text-xl text-white mb-2 group-hover:text-matrix-green transition-colors duration-300" data-id="element-41">
                  {benefit.title}
                </h3>
                <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-42">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}